// src/neetjee_guru/components/academicPlanner/FilterControlBar.js
import React, { Component } from "react";
import PlannerPDFExport from "./PlannerPDFExport";

const SUBJECT_COLORS = {
  math:   { active: "#8b5cf6", light: "#faf5ff" },
  physic: { active: "#3b82f6", light: "#eff6ff" },
  chem:   { active: "#10b981", light: "#f0fdf4" },
  botan:  { active: "#059669", light: "#ecfdf5" },
  zoolog: { active: "#f59e0b", light: "#fffbeb" },
};

function getSubjectPillStyle(subject, isActive) {
  const s = (subject || "").trim().toLowerCase();
  for (const [key, val] of Object.entries(SUBJECT_COLORS)) {
    if (s.includes(key)) {
      return isActive
        ? { background: val.active, color: "#fff", border: `1.5px solid ${val.active}` }
        : { background: "#f1f5f9", color: "#64748b", border: "1.5px solid #e2e8f0" };
    }
  }
  return isActive
    ? { background: "#334155", color: "#fff", border: "1.5px solid #334155" }
    : { background: "#f1f5f9", color: "#64748b", border: "1.5px solid #e2e8f0" };
}

const CATEGORIES = [
  { key: "All",     label: "All Days", icon: "fal fa-calendar-alt"        },
  { key: "Regular", label: "Lessons",  icon: "fal fa-chalkboard-teacher"  },
  { key: "Exam",    label: "Exams",    icon: "fal fa-file-alt"            },
  { key: "Holiday", label: "Holidays", icon: "fal fa-umbrella-beach"      },
];

const CAT_COLORS = {
  All:     { active: "#7c3aed", bg: "#f5f3ff" },
  Regular: { active: "#0284c7", bg: "#f0f9ff" },
  Exam:    { active: "#0891b2", bg: "#ecfeff" },
  Holiday: { active: "#dc2626", bg: "#fef2f2" },
};

class FilterControlBar extends Component {
  render() {
    const {
      searchText, onSearchChange,
      activeSubjects, onSubjectToggle,
      activeCategory, onCategoryChange,
      viewMode, onViewModeChange,
      streamName,
      scopeMode, onScopeModeChange,
      selectedBranch, onBranchChange,
      selectedSection, onSectionChange,
      userRole, onOpenShiftModal,
      plannersList, selectedPlannerId, onPlannerChange,
      branchesList, sectionsList,
      // Date range filter props
      dateFrom, dateTo, onDateFromChange, onDateToChange, onDateReset,
      // PDF export
      filteredDays, plannerName,
    } = this.props;

    const { allSubjects } = this.props;
    const defaultStreamSubs = (streamName === "NEET" || (streamName && streamName.includes("BiPC")))
      ? ["Botany", "Zoology", "Physics", "Chemistry"]
      : ["Mathematics", "Physics", "Chemistry"];

    let availableSubjects = (allSubjects && allSubjects.length > 0)
      ? allSubjects
      : defaultStreamSubs;

    const liveBranches = branchesList && branchesList.length > 0 ? branchesList : [];
    const liveSections = sectionsList && sectionsList.length > 0 ? sectionsList : [];

    const VIEW_MODES = [
      { key: "timeline", icon: "fal fa-stream",        label: "Timeline" },
      { key: "table",    icon: "fal fa-table",          label: "Table"    },
      { key: "calendar", icon: "fal fa-th-large",       label: "Calendar" },
    ];

    const hasDateFilter = !!(dateFrom || dateTo);

    return (
      <div style={{ background: "#f8fafc", borderRadius: 14, border: "1px solid #e2e8f0", padding: "16px 18px", marginBottom: 20 }}>

        {/* ── ROW 1: Scope + Section + Shift ───────────────────────────────────────── */}
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3" style={{ gap: 10 }}>
          <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
            {/* Scope Toggle */}
            <span className="small text-muted font-weight-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
              Scope:
            </span>
            <div style={{ display: "flex", borderRadius: 8, overflow: "hidden", border: "1.5px solid #e2e8f0", background: "#fff" }}>
              {["Institute", "Branch"].map(mode => (
                <button
                  key={mode}
                  type="button"
                  onClick={() => onScopeModeChange && onScopeModeChange(mode)}
                  style={{
                    padding: "6px 14px",
                    border: "none",
                    fontWeight: 700,
                    fontSize: "12px",
                    cursor: "pointer",
                    background: scopeMode === mode ? "#7c3aed" : "transparent",
                    color: scopeMode === mode ? "#fff" : "#64748b",
                    transition: "all 0.15s"
                  }}
                >
                  <i className={`fal fa-${mode === "Institute" ? "university" : "building"} mr-1`} />
                  {mode === "Institute" ? "Institute Master" : "Branch Specific"}
                </button>
              ))}
            </div>

            {/* Branch & Section Select (Visible ONLY in Branch Specific mode) */}
            {scopeMode === "Branch" && (
              <>
                <select
                  className="form-control form-control-sm"
                  style={{ width: "auto", borderRadius: 8, fontSize: "12px", fontWeight: 600 }}
                  value={selectedBranch}
                  onChange={e => onBranchChange && onBranchChange(e.target.value)}
                >
                  {liveBranches.length > 0
                    ? liveBranches.map(b => <option key={b.id} value={String(b.id)}>{b.branch_name || b.name}</option>)
                    : <option value="" disabled>Loading campuses…</option>
                  }
                </select>

                <select
                  className="form-control form-control-sm"
                  style={{ width: "auto", borderRadius: 8, fontSize: "12px", fontWeight: 600 }}
                  value={selectedSection}
                  onChange={e => onSectionChange && onSectionChange(e.target.value)}
                >
                  <option value="ALL">All Sections</option>
                  {liveSections.map(sec => (
                    <option key={sec.id || sec} value={sec.section_name || sec}>
                      {sec.section_name || sec}
                    </option>
                  ))}
                </select>
              </>
            )}
          </div>

          {/* Right: Shift Schedule + PDF Export */}
          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            {userRole === "Admin" && onOpenShiftModal && (
              <button
                type="button"
                onClick={onOpenShiftModal}
                title="Shift schedule dates"
                style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  padding: "7px 14px", borderRadius: 10,
                  border: "1.5px solid #f59e0b", background: "#fff",
                  color: "#92400e", fontWeight: 700, fontSize: "12px",
                  cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.18s"
                }}
                onMouseEnter={e => { e.currentTarget.style.background = "#fffbeb"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "#fff"; }}
              >
                <i className="fal fa-calendar-plus" style={{ fontSize: 13 }} />
                Shift Schedule
              </button>
            )}

            <PlannerPDFExport
              filteredDays={filteredDays || []}
              activeSubjects={activeSubjects || []}
              plannerName={plannerName || "Academic Master Planner"}
              streamName={streamName}
            />
          </div>
        </div>

        {/* ── ROW 2: Search + Date Range + View Toggle ─────────────────────────────── */}
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3" style={{ gap: 10 }}>
          {/* Search */}
          <div style={{ position: "relative", minWidth: 220, flex: "1 1 220px", maxWidth: 380 }}>
            <i className="fal fa-search" style={{
              position: "absolute", left: 11, top: "50%",
              transform: "translateY(-50%)", color: "#94a3b8", fontSize: 13
            }} />
            <input
              type="text"
              value={searchText}
              onChange={onSearchChange}
              placeholder="Search topics, exams, or holidays…"
              style={{
                width: "100%", paddingLeft: 34, paddingRight: searchText ? 34 : 12,
                paddingTop: 8, paddingBottom: 8,
                borderRadius: 10, border: "1.5px solid #e2e8f0",
                fontSize: "13px", outline: "none", background: "#fff",
                transition: "border-color 0.2s"
              }}
              onFocus={e => { e.target.style.borderColor = "#7c3aed"; }}
              onBlur={e => { e.target.style.borderColor = "#e2e8f0"; }}
            />
            {searchText && (
              <button
                type="button"
                onClick={() => onSearchChange({ target: { value: "" } })}
                style={{
                  position: "absolute", right: 10, top: "50%",
                  transform: "translateY(-50%)", border: "none",
                  background: "transparent", color: "#94a3b8", cursor: "pointer", padding: 0
                }}
              >
                <i className="fal fa-times-circle" />
              </button>
            )}
          </div>

          {/* Date Range Filter */}
          <div className="d-flex align-items-center" style={{ gap: 6 }}>
            <span className="small font-weight-bold text-muted text-uppercase" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>
              <i className="fal fa-calendar-week mr-1" />
              Date:
            </span>
            <input
              type="date"
              value={dateFrom || ""}
              onChange={e => onDateFromChange && onDateFromChange(e.target.value)}
              title="From date"
              style={{
                border: `1.5px solid ${hasDateFilter ? "#7c3aed" : "#e2e8f0"}`,
                borderRadius: 8, padding: "6px 10px", fontSize: "12px",
                fontWeight: 600, outline: "none", background: "#fff",
                color: dateFrom ? "#1e293b" : "#94a3b8"
              }}
            />
            <span style={{ color: "#94a3b8", fontWeight: 600 }}>→</span>
            <input
              type="date"
              value={dateTo || ""}
              onChange={e => onDateToChange && onDateToChange(e.target.value)}
              title="To date"
              style={{
                border: `1.5px solid ${hasDateFilter ? "#7c3aed" : "#e2e8f0"}`,
                borderRadius: 8, padding: "6px 10px", fontSize: "12px",
                fontWeight: 600, outline: "none", background: "#fff",
                color: dateTo ? "#1e293b" : "#94a3b8"
              }}
            />
            {hasDateFilter && (
              <button
                type="button"
                onClick={() => onDateReset && onDateReset()}
                title="Clear date filter"
                style={{
                  border: "1.5px solid #e2e8f0", borderRadius: 8,
                  padding: "6px 10px", background: "#fff",
                  color: "#ef4444", fontWeight: 700, fontSize: "12px",
                  cursor: "pointer"
                }}
              >
                <i className="fal fa-times" />
              </button>
            )}
          </div>

          {/* View Mode Buttons */}
          <div style={{ display: "flex", borderRadius: 10, overflow: "hidden", border: "1.5px solid #e2e8f0", background: "#fff", flexShrink: 0 }}>
            {VIEW_MODES.map(vm => (
              <button
                key={vm.key}
                type="button"
                onClick={() => onViewModeChange && onViewModeChange(vm.key)}
                title={`${vm.label} View`}
                style={{
                  padding: "7px 14px",
                  border: "none",
                  borderRight: "1px solid #e2e8f0",
                  fontWeight: 700,
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  background: viewMode === vm.key ? "#7c3aed" : "transparent",
                  color: viewMode === vm.key ? "#fff" : "#64748b",
                  transition: "all 0.15s",
                  whiteSpace: "nowrap"
                }}
              >
                <i className={vm.icon} style={{ fontSize: 13 }} />
                {vm.label}
              </button>
            ))}
          </div>
        </div>

        {/* ── ROW 3: Subject Isolation Pills + Category Filters ─────────────────────── */}
        <div className="d-flex flex-wrap align-items-center justify-content-between" style={{ gap: 10 }}>
          {/* Subject Pills */}
          <div className="d-flex flex-wrap align-items-center" style={{ gap: 6 }}>
            <span className="small text-muted font-weight-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.4px" }}>
              Subjects:
            </span>
            {availableSubjects.map(sub => {
              const isActive = activeSubjects && activeSubjects.includes(sub);
              const pillStyle = getSubjectPillStyle(sub, isActive);
              return (
                <button
                  key={sub}
                  type="button"
                  onClick={() => onSubjectToggle && onSubjectToggle(sub)}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 5,
                    padding: "5px 12px", borderRadius: 20,
                    fontSize: "12px", fontWeight: 700,
                    cursor: "pointer", transition: "all 0.15s",
                    ...pillStyle
                  }}
                >
                  <span style={{
                    width: 6, height: 6, borderRadius: "50%",
                    background: isActive ? "rgba(255,255,255,0.8)" : "#94a3b8",
                    flexShrink: 0
                  }} />
                  {sub}
                </button>
              );
            })}
          </div>

          {/* Category Filter Buttons */}
          <div className="d-flex flex-wrap align-items-center" style={{ gap: 6 }}>
            {CATEGORIES.map(cat => {
              const isActive = activeCategory === cat.key;
              const cc = CAT_COLORS[cat.key];
              return (
                <button
                  key={cat.key}
                  type="button"
                  onClick={() => onCategoryChange && onCategoryChange(cat.key)}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 5,
                    padding: "5px 13px", borderRadius: 20,
                    fontSize: "12px", fontWeight: 700,
                    cursor: "pointer", transition: "all 0.15s",
                    border: `1.5px solid ${isActive ? cc.active : "#e2e8f0"}`,
                    background: isActive ? cc.active : "#fff",
                    color: isActive ? "#fff" : "#64748b"
                  }}
                >
                  <i className={cat.icon} style={{ fontSize: 11 }} />
                  {cat.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default FilterControlBar;
